export const EXTERNAL_LINK = 'main-header.external-link',
  MULTIPLE_EXTERNAL_LINK = 'main-header.multiple-external-link',
  INTERNAL_LINK = 'menu.page',
  ORGANIZATIONAL_LINK = 'menu.organizational-unit'
